import * as React from 'react'
import Checkbox from '@/modules/drivers/shared/Checkbox'

interface TableHeaderCheckboxProps {
  checked: boolean
  onChange: () => void
  isSelectedAny: boolean
}

const TableHeaderCheckbox: React.FC<TableHeaderCheckboxProps> = ({
  checked,
  onChange,
  isSelectedAny,
}) => {
  return (
    <th
      onClick={(e) => e.stopPropagation()}
      className="tw-w-12 tw-border-b tw-border-base-300 tw-bg-content-primary tw-px-4 tw-py-3"
    >
      <label className="tw-inline-flex tw-items-center">
        <Checkbox onChange={onChange} disabled={false} checked={checked} />
      </label>
    </th>
  )
}

export default TableHeaderCheckbox


